import { useState, useEffect } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Stack, Typography, CircularProgress, Chip } from '@mui/material';
type TrustBoxPriceDetailsStockLabelProps = {
  stock: number;
};
export const TrustBoxPriceDetailsStockLabel = ({
  stock
}: TrustBoxPriceDetailsStockLabelProps) => {
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setTimeout(() => setIsLoading(false), 2000);
  }, []);
  if (stock === 0) {
    return null;
  }
  const verifyingLabel = isLoading ? 'Stock: Verifying...' : 'Stock:';
  return <Stack data-sentry-element="Stack" data-sentry-component="TrustBoxPriceDetailsStockLabel" data-sentry-source-file="TrustBoxPriceDetailsStockLabel.tsx">
      <Typography variant="bodyMediumPrimary" sx={{
      color: 'text.primary'
    }} data-sentry-element="Typography" data-sentry-source-file="TrustBoxPriceDetailsStockLabel.tsx">
        {verifyingLabel}
      </Typography>
      <Stack direction="row" sx={{
      alignItems: 'center',
      display: 'inline-flex',
      transition: 'all 0.5s ease',
      py: 0.5,
      pr: 2,
      mt: 1
    }} data-sentry-element="Stack" data-sentry-source-file="TrustBoxPriceDetailsStockLabel.tsx">
        {isLoading ? <CircularProgress size={24} sx={{
        color: 'text.primary'
      }} /> : <>
            <Chip icon={<CheckCircleIcon />} label={stock} sx={{
          px: 0.5,
          bgcolor: '#00ED8E',
          color: 'text.primary',
          '.MuiChip-icon': {
            color: 'text.primary'
          },
          '.MuiChip-label': {
            fontSize: 16,
            fontWeight: 600
          }
        }} />
          </>}
      </Stack>
    </Stack>;
};